import { render, staticRenderFns } from "./EmailSubscription.vue?vue&type=template&id=31a83958&scoped=true&"
import script from "./EmailSubscription.vue?vue&type=script&lang=ts&"
export * from "./EmailSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./EmailSubscription.vue?vue&type=style&index=0&id=31a83958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a83958",
  null
  
)

export default component.exports